import React from 'react';

// A <div> that behaves like a <button> — click + keyboard (Enter/Space)
// activation, focusable, with aria-disabled support.
//
// Why this exists: the desktop toolbar (back/forward, search, notification
// bell, user menu) lives inside the last react-bootstrap <Tab>'s title, which
// react-bootstrap renders as a <button role="tab">. A real <button> nested in
// that button is invalid DOM (validateDOMNesting warning) and breaks
// focus/click behavior, so every interactive element in that toolbar must be
// a button-like div instead. Styling is identical because the toolbar's CSS
// classes fully specify background/border/display/font rather than relying on
// <button> element defaults.
const ClickableDiv = React.forwardRef(function ClickableDiv(
    { onClick, disabled = false, className, children, ...rest },
    ref
) {
    const activate = (e) => {
        if (disabled) return;
        if (e.type === 'keydown') {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault(); // stop Space from scrolling the page
        }
        onClick?.(e);
    };

    return (
        <div
            ref={ref}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled || undefined}
            className={className}
            onClick={activate}
            onKeyDown={activate}
            {...rest}
        >
            {children}
        </div>
    );
});

export default ClickableDiv;
